import angular from 'angular';
import loansSignUpConfirmationModalComponent from './loansSignUpConfirmationModal.component';

let loansSignUpConfirmationModalModule = angular
  .module('loansSignUpConfirmationModal', [])

  .component(
    'loansSignUpConfirmationModal',
    loansSignUpConfirmationModalComponent
  ).name;

export default loansSignUpConfirmationModalModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpConfirmationModal/loansSignUpConfirmationModal.js